module.exports = __webpack_public_path__ + "img/arrow_right.dfb7c0bf.svg";